module.exports = __webpack_public_path__ + "static/img/pic-2.dce6c83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/pic-2.jpg
// module id = tSK/
// module chunks = 1